import { isPluginProduct } from '@common/api/productContext';

export interface WorkspaceSuccessPresentation {
    showDesktopHandoff: boolean;
    showPluginInstallCta: boolean;
    workspaceReadyCaptionKey:
        | 'website.welcomeModal.workspaceReady.caption'
        | 'website.welcomeModal.workspaceReady.pluginCaption';
    inviteSuccessCaptionKey:
        | 'website.welcomeModal.inviteSuccess.caption'
        | 'website.welcomeModal.workspaceReady.pluginCaption';
}

const BUSTLY_CORE_SUCCESS_PRESENTATION: WorkspaceSuccessPresentation = {
    showDesktopHandoff: true,
    showPluginInstallCta: false,
    workspaceReadyCaptionKey: 'website.welcomeModal.workspaceReady.caption',
    inviteSuccessCaptionKey: 'website.welcomeModal.inviteSuccess.caption',
};

const PLUGIN_SUCCESS_PRESENTATION: WorkspaceSuccessPresentation = {
    showDesktopHandoff: false,
    showPluginInstallCta: true,
    workspaceReadyCaptionKey: 'website.welcomeModal.workspaceReady.pluginCaption',
    inviteSuccessCaptionKey: 'website.welcomeModal.workspaceReady.pluginCaption',
};

export const resolveWorkspaceSuccessPresentation = (
    productCode?: string | null,
): WorkspaceSuccessPresentation => (
    isPluginProduct(productCode)
        ? PLUGIN_SUCCESS_PRESENTATION
        : BUSTLY_CORE_SUCCESS_PRESENTATION
);
